const BackendReducer = (state = { 
    availableBackends: [], 
    currentBackend: null, 
    loading: false, 
    error: null 
}, action) => {
    switch (action.type) {
        case 'SET_AVAILABLE_BACKENDS':
            return {
                ...state,
                availableBackends: action.payload,
                loading: false,
                error: null
            };
        case 'SET_CURRENT_BACKEND':
            return {
                ...state,
                currentBackend: action.payload
            };
        case 'SET_BACKEND_LOADING':
            return {
                ...state,
                loading: action.payload
            };
        case 'SET_BACKEND_ERROR':
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        default:
            return state;
    }
};

export default BackendReducer;
